var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalmentedeacuerdo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4caf50;}.cls-2{stroke:#000;stroke-miterlimit:10;stroke-width:13px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 84.5,
    cy: 84.5,
    r: 84.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.94,97.32s5.71,40.24,45,40.36,42-40.36,42-40.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.15,144.18H86c-23.27-.07-36.1-12.69-42.75-23.26A63.75,63.75,0,0,1,34.5,98.23l12.87-1.84c.21,1.41,5.53,34.69,38.63,34.79h.15c32.49,0,35.26-32.91,35.37-34.31l13,.88a60.76,60.76,0,0,1-7.06,22.94C121.5,131.42,109.52,144.18,86.15,144.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 48.5,
    cy: 54.75,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 119.5,
    cy: 54.75,
    r: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalmentedeacuerdo);
export default __webpack_public_path__ + "static/media/totalmente de acuerdo.0084f4a9945c05a548c76a9432bd9691.svg";
export { ForwardRef as ReactComponent };